import { MarkdownContent, Mtds, NewsImage } from 'prove-common'

export const appOptions = [
  { value: 'ProveTa', label: 'PrøveTa' },
  { value: 'ProvePlan', label: 'PrøvePlan' }
]

export const typeOptions = [
  { value: 'merge', label: 'Nye funksjoner' },
  { value: 'bug', label: 'Feilretting' }
]

export type NewsArticlePreviewProps = {
  app: string
  icon: string
  subject: string
  image?: File
  imagePreview?: string
  articleId?: number
}

export const NewsArticlePreview = ({
  app,
  icon,
  subject,
  image,
  imagePreview,
  articleId
}: NewsArticlePreviewProps) => (
  <Mtds.Group id='news-preview' className='news-preview-content'>
    <Mtds.Grid data-gap='5'>
      <Mtds.Heading as='h2' data-size='sm'>
        Forhåndsvisning
      </Mtds.Heading>
      <Mtds.Info>
        <strong>App</strong>
        {appOptions.find((option) => option.value === app)?.label ?? app}
      </Mtds.Info>
      <Mtds.Tag data-color={icon === 'bug' ? 'danger' : 'warning'}>
        {typeOptions.find((option) => option.value === icon)?.label ?? icon}
      </Mtds.Tag>
      <MarkdownContent content={subject || 'Innholdet vises her.'} />
      {image && imagePreview ? (
        <img
          src={imagePreview}
          alt='Forhåndsvisning av valgt nyhetsbilde'
          className='news-image-preview'
        />
      ) : (
        articleId != null && (
          <NewsImage articleId={articleId} className='news-image-preview' />
        )
      )}
    </Mtds.Grid>
  </Mtds.Group>
)
